import React from 'react';
import { useTranslation } from 'react-i18next';
import { discoveryCategories } from '../navConfig';

const Marquee = () => {
  const { t } = useTranslation();
  const items = [...discoveryCategories, ...discoveryCategories];

  return (
    <section
      data-testid="trust-marquee"
      className="relative border-y border-gray-100 dark:border-white/10 bg-gray-50/60 dark:bg-white/[0.02] py-5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
          <p className="shrink-0 text-[11px] font-semibold uppercase tracking-widest text-gray-400">
            {t('landing.marqueeTitle', 'Trusted across Kuwait')}
          </p>
          <div className="marquee-mask overflow-hidden flex-1">
            <div className="flex w-max items-center gap-8 animate-marquee">
              {items.map((cat, i) => {
                const Icon = cat.icon;
                return (
                  <span
                    key={`${cat.id}-${i}`}
                    className="flex items-center gap-2 text-sm font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap"
                  >
                    <Icon className={`w-4 h-4 ${cat.accent}`} />
                    {t(cat.labelKey, cat.fallback)}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Marquee;
